export type AlarmAcknowledgementState = {
    loading: boolean;
    success: boolean;
    statusCode: number;
    status: string;
    acknowledgeUser: string;
    acknowledgeTime: string;
};

export const initialAlarmAcknowledgement: AlarmAcknowledgementState = {
    loading: false,
    success: false,
    statusCode: 0,
    status: '',
    acknowledgeUser: '',
    acknowledgeTime: '',
};
